import findKeyPathOfNode from "./findKeyPathOfNode";
import keyPathToPosition from "./keyPathToPosition";

export default (tree, itemId) => {
  const keypath = findKeyPathOfNode(tree, itemId);
  const position = keyPathToPosition(keypath);
  return position;
};
